import { makeStyles } from '@barracuda-internal/bds-core'

export default makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8
  }
}))
